import CircularProgress from '@mui/material/CircularProgress';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/CircularProgress": CircularProgress } } });
export default ClientProvider;
